import {
    Component,
    OnInit,
    ViewContainerRef
} from '@angular/core';

import {AboutDialog} from '../about/about-dialog.component';
@Component({
    selector: 'fuse-about-dynamic',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss']
})
export class FuseAboutComponentDynamic implements OnInit {
    constructor(private readonly vcr: ViewContainerRef) {
    }

    ngOnInit() {
        this.vcr.clear();
        this.vcr.createComponent(AboutDialog);
    }
}
